export default "__VITE_ASSET__CwOOa2fE__"